import Enumerable from 'linq'

import * as webserviceModels from '../../interfaces/webservice-models'
import { DataService } from '../clients'

export class CurrencyListService {
  // tslint:disable-next-line:variable-name
  private _currencies: Array<webserviceModels.Common.currency>

  // tslint:disable-next-line:member-ordering
  static $inject = ['dataService', '$q']
  constructor(
    private dataService: DataService,
    private $q: ng.IQService,
  ) {}

  get currencies(): Array<webserviceModels.Common.currency> {
    if (this._currencies) return this._currencies
    throw new ReferenceError('The currency list has not been initialized.')
  }

  get currencyCodes(): Array<string> {
    return Enumerable.from(this.currencies)
      .select((currency) => currency.code)
      .toArray()
  }

  query(code: string, currencyCodes: boolean): Array<webserviceModels.Common.currency | string> {
    if (currencyCodes) {
      return Enumerable.from(this.currencyCodes)
        .where((currency) => currency.toLowerCase().indexOf(code.toLowerCase()) >= 0)
        .toArray()
    }

    return Enumerable.from(this.currencies)
      .where((currency) => currency.code.toLowerCase().indexOf(code.toLowerCase()) >= 0)
      .toArray()
  }

  load(forceReload: boolean = false): ng.IPromise<any> {
    const deferred = this.$q.defer()

    if (!forceReload && this._currencies) {
      deferred.resolve()
    } else {
      const response = this.dataService.listcurrencies()

      response.then(
        (success) => {
          if (success.meta.result) {
            this._currencies = success.currencies
            deferred.resolve()
          } else {
            try {
              deferred.reject(success.meta.message.merchant)
            } catch (e) {
              deferred.reject()
            }
          }
        },
        (error) => {
          try {
            deferred.reject(error.data.meta.message.merchant)
          } catch (e) {
            deferred.reject()
          }
        },
      )
    }

    return deferred.promise
  }

  refresh(): ng.IPromise<any> {
    if (this._currencies) return this.load(true)
    throw new ReferenceError('The currency list has not been initialized.')
  }
}

export default CurrencyListService
